export enum CorrectnessLevel {
  CORRECT = 'CORRECT',
  INCORRECT = 'INCORRECT',
  PARTIALLY_CORRECT = 'PARTIALLY_CORRECT',
}
